import React, { useContext, useEffect, useState } from "react";
import { Form as FinalForm, Field } from "react-final-form";
import { Container, Form, Button } from "semantic-ui-react";
import {
  combineValidators,
  composeValidators,
  hasLengthLessThan,
  isRequired
} from "revalidate";
import { observer } from "mobx-react-lite";
import { RootStoreContext } from "../../../../app/stores/rootStore";
import { INotificationSignature } from "../../../../app/models/company";
import TextAreaInput from "../../../../app/common/form/TextAreaInput";

const validate = combineValidators({
    signature: composeValidators(
    isRequired({ message: "La firma es obligatoria" }),
    hasLengthLessThan(301)({
        message: "La firma debe tener máximo 300 caracteres, los saltos de linea cuentan como caracter",
      })
  )(),
});

const NotificationSignature = () => {
  //variables para uso la informacion del userStore
  const rootStore = useContext(RootStoreContext);
  const { broker, getBroker, patchSignature , btSignature } = rootStore.companyStore;
  
  useEffect(() => {
    getBroker();
  }, [getBroker]);

  const [signatureForm] = useState<INotificationSignature>({    
    brokerId: broker?.id,
    signature : broker?.signature
  });

  const handleFinalFormSubmit = (values: any) => {
    values.signature = values.signature.trim();    
    patchSignature(values);
  };

  return (
    <div className="modalContent">
      <FinalForm
        validate={validate}
        initialValues={signatureForm}
        onSubmit={handleFinalFormSubmit}
        render={({ handleSubmit }) => (
          <Form onSubmit={handleSubmit}>
            <Container textAlign="justified">             
              
              <label>Firma</label>
              <Field
                name="signature"
                rows={5}
                value={signatureForm.signature}
                component={TextAreaInput}
              />
              
              <br />
              <br />
              <Button
                loading={btSignature}
                disabled={btSignature}
                className="ui primary button"
                color="blue"
                type="submit"
                content="Guardar"
              />
            </Container>
          </Form>
        )}
      />
    </div>
  );
};

export default observer(NotificationSignature);
